// 回复列 action diff 独立渲染组件（核心商务条款 / IP合作游戏方详情 / 权益明细 三表格回复列复用）。
// 渲染：新值 Tag（颜色按 diff 类型映射 bedrock Tag color：新增绿/编辑橙/删除灰）+ 旧值 Tag（light-grey）垂直堆叠；
// 按 diff 类型决定显示：deleted 只显示旧 Tag、added 只显示新 Tag、edited 双 Tag。

import React from 'react';
import { Tag } from '@bedrock/components';
import { ACTION_TEXT_MAP } from '../NegotiationTable/ActionTagCell';
import { ROUND_DIFF_TAG_COLOR, type RoundDiffValue } from './types';

/** 最新轮版权方未回复（action 为空）时的展示文案 */
const PENDING_ACTION_TEXT = '待确认';
/** 待确认 Tag 颜色（橙 = 待处理/进行中语义，对齐 diff 色系） */
const PENDING_TAG_COLOR = 'light-orange' as const;

export interface ActionDiffCellProps {
  /** 版权方回复 diff（action 新旧值；oldValue=历史轮） */
  diff: RoundDiffValue;
  /** 最新轮 action（新值；deleted 时为空） */
  newAction?: string;
}

const ActionDiffCell: React.FC<ActionDiffCellProps> = ({ diff, newAction }) => {
  const oldAction = diff.oldValue;
  return (
    <span className="inline-flex flex-col gap-2">
      {diff.type !== 'deleted' && newAction ? (
        <Tag
          size="small"
          text={ACTION_TEXT_MAP[newAction] || newAction || '-'}
          color={ROUND_DIFF_TAG_COLOR[diff.type]}
        />
      ) : !newAction ? (
        // 最新轮版权方未回复：展示「待确认」Tag（light-orange）
        <Tag
          size="small"
          text={PENDING_ACTION_TEXT}
          color={PENDING_TAG_COLOR}
        />
      ) : null}
      {oldAction != null ? (
        <Tag
          size="small"
          text={ACTION_TEXT_MAP[String(oldAction)] || String(oldAction) || '-'}
          color="light-grey"
          style={{
            textDecoration: 'line-through',
            color: 'var(--text-color-3)',
            width: 'fit-content',
          }}
        />
      ) : null}
    </span>
  );
};

export default ActionDiffCell;
